module.exports = __webpack_public_path__ + "static/Typescript-b0be62fe118de7aa1c10656de566db99.png";